// Definiert eine Konstante für das Standard-Profilbild, die in der gesamten Anwendung wiederverwendet werden kann.
export const DEFAULT_PROFILE_IMAGE = "/profile.png"